import { useEffect, useState } from 'react'
import { Loader2, Sparkles } from 'lucide-react'
import { cn } from '~/lib/utils'

const DEFAULT_PHRASES = [
    '생각하고 있어요',
    '근거를 살펴보는 중',
    '내용을 정리하는 중',
]

/** 1초 단위로 1~3개로 늘었다 줄었다 하는 점(…). */
function AnimatedDots() {
    const [n, setN] = useState(1)
    useEffect(() => {
        const t = setInterval(() => setN((p) => (p % 3) + 1), 450)
        return () => clearInterval(t)
    }, [])
    return <span className='inline-block w-3 text-left'>{'.'.repeat(n)}</span>
}

/**
 * 챗봇 공통 "작업 중" 표시 — 모든 대화형 인터페이스의 톤앤매너 통일.
 * 반짝이 아이콘 + 도는 스피너 + 순환 문구 + 애니메이션 점으로, 사용자가 지루하지 않게
 * 무언가 진행 중임을 보여준다. phrases를 주면 화면 맥락에 맞는 문구로 순환한다.
 */
export function ChatThinking({
    phrases = DEFAULT_PHRASES,
    className,
}: {
    phrases?: string[]
    className?: string
}) {
    const [i, setI] = useState(0)
    useEffect(() => {
        if (phrases.length <= 1) return
        const t = setInterval(() => setI((p) => (p + 1) % phrases.length), 1800)
        return () => clearInterval(t)
    }, [phrases.length])

    return (
        <div
            className={cn(
                'border-border bg-card text-muted-foreground inline-flex items-center gap-2 rounded-md border px-3 py-2 text-sm',
                className
            )}
            aria-live='polite'>
            <span className='bg-accent text-primary grid size-6 shrink-0 animate-pulse place-items-center rounded-full'>
                <Sparkles className='size-3.5' />
            </span>
            <Loader2 className='text-primary size-4 shrink-0 animate-spin' />
            <span className='text-foreground'>
                {phrases[i % phrases.length]}
                <AnimatedDots />
            </span>
        </div>
    )
}
